var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-tasks"},[(_vm.isNewProject)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('saveNewProjectFirst')))]):_c('TaskTable',{attrs:{"project":_vm.project,"isReadOnly":_vm.isBlockReadOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }